module.exports = __webpack_public_path__ + "static/img/about046.31ff871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about046.png
// module id = A6dT
// module chunks = 1